import { get } from 'lodash';
import { requestAPI } from 'services/request';

const requestTokenAPI = ({ payload, ...rest }) =>
  requestAPI('POST', '/tokens/request', payload, { auth: false, ...rest });

const revokeTokenAPI = ({ payload, ...rest }) =>
  requestAPI('POST', '/tokens/revoke', payload, { ...rest });

const request = async payload => {
  const res = await requestTokenAPI({ payload });
  return get(res, 'data', {});
};

const revoke = async payload => {
  const res = await revokeTokenAPI({ payload });
  return get(res, 'data', {});
};

export const TOKENS_API = {
  request,
  revoke,
};
